import * as React from 'react';
import { Sorting } from '@elastic/react-search-ui';
import { Config } from '../../helper';
import { OpenSearchDropdown, OpenSearchFacet, OpenSearchSearchBox, OpenSearchSelectFacet } from '../components';

const FACET_WIDGETS = {
  [Config.FacetWidgets.Multiselect]: OpenSearchDropdown,
  [Config.FacetWidgets.Dropdown]: OpenSearchSelectFacet,
};

export default function StandardLayoutFilters(props) {
  const {
    facets = [],
    sorting = [],
    showSearchBox,
    // Force the checkbox widget regardless of each facet's configured `widget`. Used in the
    // horizontal layout's offcanvas, where a dropdown-in-a-drawer (dropdown-in-dropdown)
    // reads badly — a flat checkbox list fits the drawer.
    forceCheckbox = false,
  } = props;

  const sortOptions = sorting.map(opt => {
    return {name: opt.label, value: opt.field, direction: opt.direction};
  });

  return (
    <div className='filters'>
      <div className='filters__header'>
        <p className='h--smaller filters__title d-flex align-items-center'>{Config.I18n.Filters.BlockLabel}</p>
      </div>

      {showSearchBox && <OpenSearchSearchBox/>}

      {sortOptions && sortOptions.length > 1 && (
        <div className='block block--sorting'>
          <p className='h--smallest'>{Config.I18n.Filters.SortByLabel}</p>
          <Sorting sortOptions={sortOptions}/>
        </div>
      )}

      {facets.length > 0 && facets.map(facetConfig => {
        const {field, label, hidden = false, widget, order} = facetConfig;
        // Default (empty/unknown widget) renders inline checkboxes; see FACET_WIDGETS for the
        // dropdown variants. `forceCheckbox` overrides the config to always render checkboxes.
        const FacetComponent = forceCheckbox ? OpenSearchFacet : (FACET_WIDGETS[widget] || OpenSearchFacet);

        return (
          <FacetComponent
            key={field}
            field={field}
            label={label}
            hidden={hidden}
            order={order}
            show={Config.DisplayOptions.FacetSize}
          />
        );
      })}
    </div>
  );
}
